import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SizingMethod } from 'client/voladeum/sizing-methods/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: SizingMethod[] = EMPTY_ARRAY;

export const sizingMethodsSlice = createSlice({
  name: SLICE.SIZING_METHODS,
  initialState,
  reducers: {
    setSizingMethods: (_state, action: PayloadAction<SizingMethod[]>) => {
      return action.payload;
    },
    clearSizingMethods: () => {
      return initialState;
    },
  },
});

export const { setSizingMethods, clearSizingMethods } = sizingMethodsSlice.actions;

export default sizingMethodsSlice.reducer;
